import { render, staticRenderFns } from "./OurMinistries.vue?vue&type=template&id=6a338d10&scoped=true"
import script from "./OurMinistries.vue?vue&type=script&lang=js"
export * from "./OurMinistries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a338d10",
  null
  
)

export default component.exports